import { CountriesList } from './constants/countriesList';

export const processQuestionsAnswers = (answersMap, questions) => {
  const CHECKBOX_QUESTION = 3;
  let updatedQuestions = questions;
  answersMap.forEach(function (value, key) {
    if (key.includes('question_inputN')) {
      const inputN = key.split('_')[2];
      updatedQuestions = updatedQuestions.map((q) => {
        if (isNaN(inputN)) {
          if (q.uuid === inputN) {
            q.answer = value;
          }
        } else {
          let val = parseInt(inputN);
          if (q.inputN === val) {
            q.answer = value;
          }
        }
        return q;
      });
    }
  });

  updatedQuestions = updatedQuestions.map((q) => {
    if (q.type === CHECKBOX_QUESTION && q.answer === undefined) {
      q.answer = false;
    }
    return q;
  });

  return updatedQuestions;
};

export const processQuestionsAnswersNew = (answersMap, questions) => {
  const CHECKBOX_QUESTION = 3;
  let updatedQuestions = questions;
  answersMap.forEach(function (value, key) {
    if (key.includes('question_inputN')) {
      const uuid = key.split('_')[2];
      updatedQuestions = updatedQuestions.map((lq) => {
        const q = lq.question;
        if (q.uuid === uuid) {
          q.answer = value;
        }
        return { ...lq, question: q };
      });
    }
  });

  updatedQuestions = updatedQuestions.map((lq) => {
    const q = lq.question;
    if (q.type === CHECKBOX_QUESTION && q.answer === undefined) {
      q.answer = false;
    }
    return { ...lq, question: q };
  });

  return updatedQuestions;
};

export const checkLogicalAnswer = (question, response) => {
  if (response === undefined) return false;
  let responseEnum = response ? 'yes' : 'no';
  if (question.default) responseEnum = 'no';
  return question[responseEnum].type === 'RESPONSE';
};

export const isAlternative = (item) => {
  console.log(item.question);
  if (item.question) {
    const nResp = item.question.notification ? 'yes' : 'no';
    const qResp = item.question.answer ? 'yes' : 'no';
    if (nResp === qResp && item.question.alternativeMessage) {
      return true;
    }
  }
  return false;
};

export const GetFlagCountryCode = (country = '') => {
  const selectedCountry = CountriesList?.find((val) => val?.name === country);
  return selectedCountry?.code || 'CA';
};
